import { useContext } from "react"
import Web3Ctx from "../context/Web3Ctx"

export const useWeb3Ctx = () => {
    return useContext(Web3Ctx)
}
export default useWeb3Ctx;